import{MATURITY_SYMBOL as t}from"../../constants.js";const s=({depositType:s,maturity:e,showDepositTypeInMaturity:o})=>e?o?`${e} ${s}`:`${t} ${e.replace(/\s/g," ")} ${t}`:"";export{s as default};
//# sourceMappingURL=createMaturityInfo.js.map
